
import React, { useEffect } from "react";
import { useUserDashboard } from "../../hooks/useUserDashboard";
import TabsNavigation from "./TabsNavigation";
import './DashboardStyles.css';
import SetupWizard from "./SetupWizard";
import { supabase } from "../../utils/supabase";

const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

const EnhancedLoader = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'var(--background)'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid rgba(37, 211, 102, 0.1)',
        borderTop: '3px solid var(--primary)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '1.5rem'
      }}></div>
      <div style={{
        fontSize: '1.2rem',
        fontWeight: '500',
        color: 'var(--text)',
        textAlign: 'center'
      }}>
        Loading Abra Console...
      </div>
    </div>
  );
};

interface ErrorProps {
  message: string;
}

const ErrorMessage = ({ message }: ErrorProps) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'var(--background)',
      padding: '0 2rem'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '64px',
        height: '64px',
        background: 'rgba(239, 68, 68, 0.1)',
        borderRadius: '50%',
        marginBottom: '1.5rem'
      }}>
        <ErrorIcon />
      </div>
      <div style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        color: 'var(--text)',
        marginBottom: '1rem',
        textAlign: 'center'
      }}>
        Something went wrong
      </div>
      <div style={{
        fontSize: '1rem',
        color: 'var(--text-muted)',
        maxWidth: '500px',
        textAlign: 'center',
        marginBottom: '2rem'
      }}>
        {message || "We couldn't load the console. Please try refreshing the page."}
      </div>
      <button 
        className="button-primary"
        onClick={() => window.location.reload()}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 4v6h6"/>
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
        </svg>
        <span>Refresh Page</span>
      </button>
    </div>
  );
};

export default function DashboardLayout() {
  const { 
    loading, 
    error, 
    profile, 
    apiKey, 
    step, 
    completeSetup 
  } = useUserDashboard();

  const handleSetupComplete = async () => {
    await completeSetup();
  };

  if (loading) return <EnhancedLoader />;
  if (error)   return <ErrorMessage message={error} />;

  if (step === 'setup' && !profile) {
    return <EnhancedLoader />;
  }
  if (step === 'setup') {
    return <SetupWizard profile={profile!} onSetupComplete={handleSetupComplete} />;
  }

  return <TabsNavigation apiKey={apiKey} userId={profile!.id} />;
}
